export default "__VITE_ASSET__CFJRhPMk__"